import { UserCircle } from 'lucide-react';
import { FormData } from '../../types';
import { validateEmail } from '../../utils/helpers';

interface ContactInformationProps {
  formData: FormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showErrors: boolean;
}

export const ContactInformation = ({ formData, handleInputChange, showErrors }: ContactInformationProps) => {
  const isEmailValid = formData.contactEmail ? validateEmail(formData.contactEmail) : true;

  return (
    <div className="space-y-6">
      <h2 className="text-xl sm:text-2xl font-semibold flex items-center gap-3 text-blue-900">
        <UserCircle className="text-[#6366F1]" />
        Contact Information
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Your Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactName"
            value={formData.contactName}
            onChange={handleInputChange}
            className="input-field"
            placeholder="Enter your name"
          />
          {showErrors && !formData.contactName?.trim() && (
            <p className="mt-2 text-sm text-red-600">Name is required</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email Address <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="contactEmail"
            value={formData.contactEmail}
            onChange={handleInputChange}
            className={`input-field ${!isEmailValid && formData.contactEmail && showErrors ? 'border-red-500 focus:border-red-500 focus:ring-red-200' : ''}`}
            placeholder="Enter your email"
          />
          {showErrors && !formData.contactEmail?.trim() && (
            <p className="mt-2 text-sm text-red-600">Email is required</p>
          )}
          {showErrors && formData.contactEmail && !isEmailValid && (
            <p className="mt-2 text-sm text-red-600">Please enter a valid email address</p>
          )}
        </div>
      </div>
    </div>
  );
};